import { CanActivateFn } from "@angular/router";
import { AuthGuardData, createAuthGuard } from "keycloak-angular";
import { TestService } from "../services/test.service";

export const IsAuthenticated = createAuthGuard<CanActivateFn>(async (_, __, authData: AuthGuardData) => {
  if (TestService.isRunningInFrontendTestContext) {
    return true;
  }

  return authData.authenticated;
});
